import React from 'react';
function Store({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M14 14h5v8h-5v-8z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M21 10v12H3V10" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M5 14h6v5H5v-5zM17.5 7.5L15.667 2 17.5 7.5zM19.553 2H4.447L1 7.5c0 .663.29 1.299.805 1.768A2.896 2.896 0 003.75 10c.73 0 1.429-.263 1.945-.732A2.39 2.39 0 006.5 7.5c0 .663.29 1.299.805 1.768A2.896 2.896 0 009.25 10c.73 0 1.429-.263 1.945-.732A2.39 2.39 0 0012 7.5c0 .663.29 1.299.805 1.768A2.896 2.896 0 0014.75 10c.73 0 1.429-.263 1.945-.732A2.39 2.39 0 0017.5 7.5c0 .663.29 1.299.805 1.768A2.896 2.896 0 0020.25 10c.73 0 1.429-.263 1.945-.732A2.39 2.39 0 0023 7.5L19.553 2zM1 7.333h22H1zM12 2v5.5V2zM6.5 7.5L8.333 2 6.5 7.5z"
      />
    </svg>
  );
}

export default Store;
